import React from 'react';
import { PaginationItem, Pagination, PaginationProps } from '@material-ui/lab';
import { withStyles } from '@material-ui/core';
// eslint-disable-next-line import/named
import { variant } from 'src/materialConfig/customTypography';

const StylesPaginationItem = withStyles((theme) => ({
  root: {
    height: '25px',
    minWidth: '25px',
    // border: '1px solid #EDEDED',
    ...variant.smallText,
  },
  page: {
    border: '1px solid #EDEDED',
    borderRadius: '2px',
  },
  selected: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: 'white',
  },
}))(PaginationItem);

export const BasePagination: React.FC<PaginationProps> = (props) => {
  return (
    <Pagination
      renderItem={(item) => <StylesPaginationItem {...item} />}
      {...props}
    />
  );
};
